/*
 *  Copyright (c) 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Tab, Tabs } from "@nordcloud/gnui";
import { SpendsChart } from "~/components";
import { useLexicalTabsWithUrl } from "~/hooks";
import { RouteParams } from "../types";
import { ApplicationBudgetSection } from "./ApplicationBudgetSection";
import { ApplicationCostAnalysisSection } from "./ApplicationCostAnalysisSection";
import { CostDetailsTab } from "./CostDetailsTab";

type Props = {
  costsLoading: boolean;
  currentMonthCosts: string[];
  events: React.ComponentProps<typeof SpendsChart>["events"];
  forecast: number;
};

export function ApplicationCostTabs({
  costsLoading,
  currentMonthCosts,
  events,
  forecast,
}: Props) {
  const { activeTab, setActiveTab, registerTabs } =
    useLexicalTabsWithUrl("costTab");
  const { application } = useParams<RouteParams>();

  useEffect(() => {
    registerTabs(["analysis", "budget", "cost"]);
    // we don't want registerTabs to avoid excessive recursion
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Tabs handleTab={setActiveTab} step={activeTab}>
      <Tab heading="Cost analysis">
        <ApplicationCostAnalysisSection
          appId={application}
          forecast={forecast}
        />
      </Tab>
      <Tab heading="Budget">
        <ApplicationBudgetSection appId={application} />
      </Tab>
      <Tab heading="Cost details">
        <CostDetailsTab
          loading={costsLoading}
          currentMonthCosts={currentMonthCosts}
          events={events}
        />
      </Tab>
    </Tabs>
  );
}
